import { Reveal, Eyebrow } from "./Reveal";
import { CHAPTERS, IMAGES } from "./data";
import { useSite } from "@/lib/site";

export const About = () => {
  const { content } = useSite();
  const chapters = content.about?.length ? content.about : CHAPTERS;
  return (
  <section id="about" data-testid="about-section" className="py-20 sm:py-28 lg:py-36">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-4 sm:px-8 lg:grid-cols-12 lg:gap-10 lg:px-16">
      <div className="lg:col-span-5">
        <Reveal className="relative">
          <div className="overflow-hidden rounded-[2rem] rounded-bl-[6rem] shadow-deep">
            <img
              src={content.settings?.about_image_url || IMAGES.portrait}
              alt="Yogyata Wadhwa, IBCLC"
              className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
              data-testid="about-portrait"
            />
          </div>
          <div className="absolute -bottom-6 right-6 rounded-2xl bg-ink px-6 py-4 text-sand shadow-deep">
            <p className="font-display text-xl italic">Yogyata Wadhwa</p>
            <p className="font-outfit text-xs uppercase tracking-widest text-sand/70">
              IBCLC · Physiotherapist · CBE
            </p>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7 lg:pl-8">
        <Reveal>
          <Eyebrow>{content.settings?.about_eyebrow || "The force behind The Birth Life"}</Eyebrow>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight tracking-tight text-ink">
            {content.settings?.about_heading || "A manifesto for mother-first care"}
          </h2>
        </Reveal>

        <div className="mt-12 space-y-0">
          {chapters.map((c, i) => (
            <Reveal key={c.id || c.num || i} delay={i * 0.12}>
              <div
                data-testid={`about-chapter-0${i + 1}`}
                className="group grid grid-cols-[auto_1fr] gap-6 border-t border-ink/10 py-8 transition-colors duration-500 last:border-b hover:bg-cream/50 sm:gap-10"
              >
                <span className="font-display text-3xl font-medium text-terra/60 transition-colors duration-500 group-hover:text-terra sm:text-4xl">
                  0{i + 1}
                </span>
                <div>
                  <h3 className="font-display text-xl font-semibold text-ink sm:text-2xl">{c.title}</h3>
                  <p className="mt-2 max-w-xl text-base leading-relaxed text-plumsoft">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
  );
};
